import PropTypes from "prop-types"
import React, { useRef, useState } from "react"
import { readFileAsDataUrl } from "../partnerSignupUtils"

const FileUploadInput = ({ label, value, onChange, required, error, circular }) => {
  const inputRef = useRef(null)
  const [fileError, setFileError] = useState("")

  const handleFile = async event => {
    const file = event.target.files?.[0]
    setFileError("")
    if (!file) return

    if (!file.type.startsWith("image/")) {
      setFileError("Sélectionnez un fichier image.")
      return
    }

    if (file.size > 5 * 1024 * 1024) {
      setFileError("L’image ne doit pas dépasser 5 Mo.")
      return
    }

    onChange(await readFileAsDataUrl(file), file)
  }

  return (
    <div className="partner-upload-field">
      <label>
        {label} {required && <span aria-hidden="true">*</span>}
      </label>
      <button type="button" className={`partner-upload ${circular ? "partner-upload-circular" : ""}`} onClick={() => inputRef.current?.click()}>
        {value ? (
          <>
            <img src={value} alt={`Aperçu - ${label}`} />
            <span className="partner-upload-overlay"><i className="bx bx-camera" /> Modifier</span>
          </>
        ) : (
          <span className="partner-upload-empty">
            <i className="bx bx-cloud-upload" />
            <strong>Ajouter une image</strong>
            <small>PNG, JPG ou WEBP, 5 Mo maximum</small>
          </span>
        )}
      </button>
      <input ref={inputRef} type="file" accept="image/png,image/jpeg,image/webp" onChange={handleFile} hidden />
      {(error || fileError) && <div className="partner-field-error">{error || fileError}</div>}
    </div>
  )
}

FileUploadInput.propTypes = {
  circular: PropTypes.bool,
  error: PropTypes.string,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  value: PropTypes.string,
}

export default FileUploadInput
